"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Options for replacing tags using double curly braces (`{{` `}}`).
 * Matches tags of the form `{{variable}}` in the text.
 * @example
 * // Example usage:
 * const text = 'Hello {{variable}}';
 * const result = replaceTags(text, { variable: 'world' }, DoubleCurlyBraces);
 * console.log(result); // Output: 'Hello world'
 */
var DoubleCurlyBraces = {
    name: "Double Curly Braces",
    openingTag: "{{",
    closingTag: "}}",
    tagPattern: /\{\{([^}]+)\}\}/g,
    tagStartPattern: /^\{\{/,
    tagEndPattern: /\}\}$/,
};
exports.default = DoubleCurlyBraces;
